import { render, staticRenderFns } from "./CustomerTemp.vue?vue&type=template&id=5ddb6488"
import script from "./CustomerTemp.vue?vue&type=script&lang=js"
export * from "./CustomerTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports